/**
* @global
* @name config
* @prop {boolean} warnings=false
*/
const config = {
  warnings: false,
};

module.exports = config;
